export type Role = 'admin' | 'reporter' | 'court_reporter'

// Mirrors `Auth0User.role` in the backend.
export const getRole = (
  permissions: string[],
  rolesEnforced: boolean,
  courtReporterRoleEnabled: boolean,
): Role | null => {
  if (permissions.includes('reporters:admin')) {
    return 'admin'
  }
  // `digital-reporter` and `court-reporter` Auth0 roles.
  const isDigital = permissions.includes('reporters:dr-portal:access')
  const isCourt = permissions.includes('reporters:cr-portal:access')
  if (!rolesEnforced) {
    return isCourt && courtReporterRoleEnabled ? 'court_reporter' : 'reporter'
  }
  // A token with neither, or with both, has no role.
  if (isDigital && !isCourt) {
    return 'reporter'
  }
  if (isCourt && !isDigital) {
    return 'court_reporter'
  }
  return null
}
